import { createContext, useContext, useState } from 'react';

import type { Project } from '@/features/projects/types';

interface ProjectContextValue {
  selectedProject: Project | null;
  setSelectedProject: (project: Project | null) => void;
}

const ProjectContext = createContext<ProjectContextValue>({
  selectedProject: null,
  setSelectedProject: () => {},
});

const STORAGE_KEY = 'edifice:selectedProject';

function readStored(): Project | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as Project) : null;
  } catch {
    return null;
  }
}

export function ProjectProvider({ children }: { children: React.ReactNode }) {
  const [selectedProject, setSelectedProjectState] = useState<Project | null>(readStored);

  function setSelectedProject(project: Project | null) {
    setSelectedProjectState(project);
    if (project) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(project));
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  }

  return (
    <ProjectContext.Provider value={{ selectedProject, setSelectedProject }}>
      {children}
    </ProjectContext.Provider>
  );
}

export function useSelectedProject() {
  return useContext(ProjectContext);
}
